import useStyles from 'isomorphic-style-loader/useStyles';
import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useEventListener } from 'usehooks-ts';

import { useModal } from '@components/modal';

import s from './quick-search-trigger.scss';

/**
 * Top-nav button that opens quick search. Also registers the global Cmd+K
 * (Ctrl+K off Mac) shortcut to toggle it.
 */
export const QuickSearchTrigger = () => {
  useStyles(s);
  const { isOpen, open, close } = useModal('quickSearch');

  // Resolved after mount to keep SSR and the first client render in sync; the
  // modifier glyph and the matched shortcut key both depend on the platform.
  const [isMac, setIsMac] = useState(false);
  useEffect(() => {
    setIsMac(/Mac|iPhone|iPad|iPod/i.test(navigator.platform));
  }, []);

  useEventListener('keydown', event => {
    const modifierPressed = isMac ? event.metaKey : event.ctrlKey;
    if (modifierPressed && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      if (isOpen) {
        close();
      } else {
        open();
      }
    }
  });

  return (
    <button
      aria-label="Search"
      className={s.trigger}
      onClick={() => open()}
      type="button"
    >
      <Search aria-hidden className={s.icon} />
      <span className={s.label}>Search…</span>
      <kbd className={s.shortcut}>{isMac ? '⌘K' : 'Ctrl+K'}</kbd>
    </button>
  );
};

export default QuickSearchTrigger;
